import React from 'react';

// This Context stores as value the reference to the messageList of the chat
// for the purpose of printing the message list over the buttons in the Footers
// of messages.
export const MessageListRefContext = React.createContext(undefined);
